/**
 * Whether a workspace read shows the demand's pricing checks changed underneath the loaded list:
 * an edit marked the report stale (FR-5.8, HS2-N0RFQQ), or a run was added or finished elsewhere.
 * Only a list already loaded for this demand is compared, since opening a demand loads it itself.
 */
export function analysesNeedReload(
  loaded: readonly { id: string; status: string }[],
  rows: readonly { id: string; status?: unknown }[],
): boolean {
  if (loaded.length === 0) return false;
  const statusById = new Map(rows.map((row) => [row.id, row.status]));
  // None of the loaded runs are in this read: the list belongs to another demand.
  if (!loaded.some((analysis) => statusById.has(analysis.id))) return false;
  return rows.length !== loaded.length || loaded.some((analysis) => statusById.get(analysis.id) !== analysis.status);
}
